import { render, staticRenderFns } from "./SettingsAccounting.vue?vue&type=template&id=bfc10772&scoped=true&"
import script from "./SettingsAccounting.vue?vue&type=script&lang=ts&"
export * from "./SettingsAccounting.vue?vue&type=script&lang=ts&"
import style0 from "./SettingsAccounting.vue?vue&type=style&index=0&id=bfc10772&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfc10772",
  null
  
)

export default component.exports